export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8090' : 'https://report.mtn.mobivs.com/serve';